import { Component, OnDestroy, OnInit } from '@angular/core';
import { DateRange, extractDateRange, extractNumber, HxProductService, isoDate, ProductDiscardInfoModel } from 'hx-services';
import { HxErrorHandlerService, HxLoaderComponent } from 'hx-component';
import { Subscription } from 'rxjs';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { DatePipe, NgClass, NgFor, NgIf } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
    selector: 'app-product-discard-info.m-grid__item.m-grid__item--fluid.m-wrapper',
    templateUrl: './product-discard-info.component.html',
    styleUrls: ['./product-discard-info.component.css'],
    imports: [NgIf, NgFor, NgClass, RouterLink, HxLoaderComponent, DatePipe, TranslocoPipe]
})
export class ProductDiscardInfoComponent implements OnInit, OnDestroy {
  list: ProductDiscardInfoModel[] = [];
  isLoading = {
    list: true
  };
  params: {storeId?: number, date?: DateRange, productTitle?: string, productInfoId?: number, groupByDate: boolean} = {groupByDate: true};
  private sub: Subscription;

  constructor(
    private productService: HxProductService,
    private errorHandlerService: HxErrorHandlerService,
    private aRoute: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.sub = this.aRoute.queryParamMap.subscribe(paramMap => {
      this.params.date = extractDateRange('date', paramMap) ?? {from: isoDate(Date.now()), to: isoDate(Date.now())};
      this.params.storeId = extractNumber('storeId', paramMap);
      this.params.productTitle = paramMap.get('productTitle');
      this.params.productInfoId = extractNumber('productInfoId', paramMap);
      this.loadList();
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  private loadList() {
    this.isLoading.list = true;
    this.list = [];

    this.productService.getProductDiscards(this.params).subscribe(
      result => {
        this.list = result;
        this.isLoading.list = false;
      }, err => {
        this.errorHandlerService.check(err);
        this.isLoading.list = false;
      }
    );
  }
}
